export default __webpack_public_path__ + "static/Logo_Black_Simpler-6b6dc036cf2b69b41dc30f84a07d4427.svg";